import Vue from "vue";

export default {
    initData(state, payload){
        state.isLoaded = true;
        if (payload.code < 0) {
            state.isConfig = false;
            return false;
        }
        state.isConfig = true;
        const category = payload.data.category;
        const config = payload.data.config;
        state.game_name = config.game_name;
        state.top_background = config.top_background;
        state.top_game_icon = config.top_game_icon;
        state.top_down_button = config.top_down_button;
        state.feature = config.feature;
        state.home_image = config.home_image;
        state.home_down_image = config.home_down_image;

        state.logo = config.logo;
        state.is_logo = config.is_logo;
        state.qrcode = config.qrcode;
        state.is_qrcode = config.is_qrcode;
        state.apk_link = config.apk_link;

        state.promotional_video = config.promotional_video;
        state.bottom_info = config.bottom_info;
        
        if( state.articleList.length == 0 ) {
            category.forEach((item)=>{
                state.articleList.push(item)
            });
        }

        document.title = config.title;

        localStorage.setItem('app_id', config.app_id);
        localStorage.setItem('said', config.said);
    },
    activeTab(state, index){
        state.activeTab = index
    },
    currentCate(state, id) {
        state.currentCateId = id
    },
}


// WEBPACK FOOTER //
// ./src/store/mutations.js